import { get } from 'lodash';
import { connect } from 'react-redux';
import PaymentScheduleLink from '../components/payment-schedule-link';

const mapStateToProps = ({ purchases, memberships, projections }, ownProps) => {
  const purchase = purchases.byId[purchases.current];
  const membership = get(projections, `${ownProps.namespace}.memberships.${memberships.current}`);

  if (!membership) return {};

  const baseIx = purchase.payments[0].number;
  const payments = membership.contributions.map((contribution, i) => {
    return {
      id: contribution.paymentId,
      amount: contribution.amount,
      dueDeadline: contribution.dueDeadline,
      status: contribution.status,
      number: i + baseIx,
      forMember: true,
    };
  });

  return {
    constraints: ownProps.constraints,
    costComponents: [],
    costs: [],
    costType: purchase.costType,
    payments,
    refundableAmount: membership.refundableAmount,
    totalAmount: membership.amount,
    consumerFee: membership.fees.consumerFee,
    asIcon: ownProps.asIcon,
  };
};

export default connect(mapStateToProps)(PaymentScheduleLink);



// WEBPACK FOOTER //
// ./src/desktop/containers/member-payments-schedule-link.container.js